import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import type { Skill } from './types';

interface CreateSkillParams {
  name: string;
  description: string;
  skillFile: File;
}

export const createSkill = async ({
  name,
  description,
  skillFile,
}: CreateSkillParams): Promise<Skill> => {
  const { currentOrg } = useOrgStore.getState();
  const orgId = currentOrg?.orgid;
  if (!orgId) throw new Error('No organization selected');

  const formData = new FormData();
  formData.append('name', name);
  formData.append('description', description);
  formData.append('skill_file', skillFile);

  const response = await apiRequest<Skill>({
    url: `/skills/${orgId}`,
    method: 'POST',
    body: formData,
    formData: true,
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) throw new Error('Failed to create skill');
  return response.data;
};
